import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment-wrapper'
import { Listing } from '../../../classes/listing';
@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() listing: Listing;
  @Input() id: string;
  @Input() isLandingPage: boolean = false;
  @Output() toggleEmailModal: EventEmitter<any> = new EventEmitter();
  @Output() onOutsideClick: EventEmitter<any> = new EventEmitter();
  cdnUrl = environment.cdnServerUrl

  constructor() { }

  ngOnInit() {
  }

  openPopup(url, title) {
    window.open(url, `${title} Share listing`, `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${(window.innerWidth / 2) - 225},toolbar=0, location=0, menubar=0, directories=0, scrollbars=0 `)
  }

  toggleModal() {
    
    this.toggleEmailModal.emit()
  }

  close() {
    this.onOutsideClick.emit();
  }
}
